import { render, staticRenderFns } from "./ITRIncomeFormsPresenceCard.vue?vue&type=template&id=d326e4e4&scoped=true&"
import script from "./ITRIncomeFormsPresenceCard.vue?vue&type=script&lang=ts&"
export * from "./ITRIncomeFormsPresenceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d326e4e4",
  null
  
)

export default component.exports